import React from 'react'
import { OfferPageDispatchAction } from './offerPageStateReducer'

const OfferPageDispatchContext = React.createContext<React.Dispatch<OfferPageDispatchAction>>(undefined)

export default OfferPageDispatchContext
